/* Elegancecoque Luxe - « ACHETER MAINTENANT » sur la fiche produit.
   Le bouton porte la classe « es-popup-button-overwrite » documentée par EasySell : quand l'appli est installée
   et que l'interrupteur « Appli de commande à la livraison installée » (section « Parcours d'achat ») est coché,
   c'est l'appli qui ouvre sa fenêtre de commande avec la variante et la quantité du formulaire produit ;
   ce script ne fait alors rien.
   Sinon (appli absente) : ajoute l'article et ouvre le paiement Shopify, comme avant. */
(function(){
var doc=document;
function cfg(){try{return JSON.parse((doc.getElementById('ec-parcours-config')||{}).textContent||'{}');}catch(e){return {};}}
function codApp(){return !!(cfg().cod_app||window.__ecCodApp);}
function root(){return (window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';}
doc.addEventListener('click',function(e){
 var b=e.target.closest&&e.target.closest('[data-luxe-buynow]');
 if(!b){return;}
 if(codApp()){
  /* EasySell ouvre sa fenêtre. Si son script n'était pas encore prêt (mobile lent), on relance une fois. */
  if(!e.isTrusted||b.__ecRetry){return;}
  var cx=Math.round(window.innerWidth/2),cy=Math.round(window.innerHeight/2);
  function fixedAt(){var el=doc.elementFromPoint(cx,cy);while(el&&el!==doc.body){if(window.getComputedStyle(el).position==='fixed'){return el;}el=el.parentElement;}return null;}
  var before=fixedAt();
  b.__ecRetry=true;
  window.setTimeout(function(){var now=fixedAt();if(!now||now===before){b.click();}window.setTimeout(function(){b.__ecRetry=false;},1500);},1400);
  return;
 }
 e.preventDefault();
 if(b.classList.contains('is-loading')){return;}
 var form=b.closest('form');
 var idEl=form&&form.querySelector('[name=id]');
 if(!idEl||!idEl.value){return;}
 var qEl=form.querySelector('[name=quantity]');
 var qty=parseInt(qEl&&qEl.value,10);
 if(!qty||qty<1){qty=1;}
 var item={id:Number(idEl.value),quantity:qty};
 var mf=doc.querySelector('[data-luxe-mf-select]');
 if(mf&&mf.value){item.properties={'Modèle iPhone':mf.value};}
 var label=b.textContent;
 b.classList.add('is-loading');
 window.fetch(root()+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[item]})})
  .then(function(r){if(!r.ok){throw new Error('add');}return r.json();})
  .then(function(){window.location.href=root()+'checkout';})
  .catch(function(){b.classList.remove('is-loading');b.textContent='Erreur, réessayez';window.setTimeout(function(){b.textContent=label;},2500);});
});
})();